import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const faqs = [
    {
      question: "Preciso de ingredientes caros?",
      answer: "Não. Tudo foi pensado com ingredientes comuns e econômicos que você encontra em qualquer mercado. A proposta é justamente usar o que você já tem em casa.",
    },
    {
      question: "Consigo cozinhar mesmo sendo iniciante?",
      answer: "Sim! As receitas têm passo a passo claro, com quantidades exatas e tempo total indicado. Foram criadas pensando em quem não domina a cozinha.",
    },
    {
      question: "Dá para adaptar se faltar algo?",
      answer: "Sim. Várias receitas incluem substituições e variações sugeridas. Você pode adaptar conforme os ingredientes que tiver disponíveis no momento.",
    },
    {
      question: "Em quanto tempo recebo o e-book?",
      answer: "O acesso é imediato! Assim que sua compra for confirmada, você receberá o link para download do PDF no seu e-mail.",
    },
    {
      question: "Serve para quantas porções?",
      answer: "A maioria das receitas foi pensada para família (4 porções). Incluímos indicações de como ajustar as quantidades para mais ou menos pessoas.",
    },
    {
      question: "Posso imprimir o e-book?",
      answer: "Sim! O e-book é um PDF que você pode ler em qualquer dispositivo ou imprimir as receitas que quiser para ter na cozinha.",
    },
    {
      question: "Tem receitas vegetarianas?",
      answer: "Sim! O e-book inclui opções variadas, incluindo receitas vegetarianas e sugestões de substituições para adaptar outras receitas.",
    },
  ];

  return (
    <section className="py-16 lg:py-24 bg-muted/30">
      <div className="container">
        <div className="text-center mb-12 animate-fade-in">
          <h2 className="text-3xl font-bold tracking-tight sm:text-4xl mb-4">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Tire suas dúvidas sobre o e-book
          </p>
        </div>

        <Accordion type="single" collapsible className="max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <AccordionItem 
              key={index} 
              value={`item-${index}`}
              className="border-2 bg-background mb-4 px-6 rounded-lg"
            >
              <AccordionTrigger className="text-left hover:no-underline py-4">
                <span className="font-bold">{faq.question}</span>
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground pb-4">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
